module.exports = {"410773001":"龙源街道","410773101":"原武镇","410773102":"师寨镇","410773106":"韩董庄镇","410773203":"祝楼乡","410773204":"桥北乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410773.json
// module id = 1594
// module chunks = 0